import { Component } from '@angular/core';
import { AuthService } from '@aiwyn/auth';
import { Router } from '@angular/router';
import { AssetUriService } from '@aiwyn/config';
import { ROUTE_TOKEN_LOGIN, ROUTE_TOKEN_MAIN_BASE } from '../../../routing-constants';
import { switchMap, take, tap } from 'rxjs/operators';

@Component({
  selector: 'app-reset-password-wait',
  templateUrl: './reset-password-wait.component.html',
  styleUrls: ['./reset-password-wait.component.scss'],
  standalone: false,
})
export class ResetPasswordWaitComponent {
  emailAddress: string = null;

  constructor(
    public assetUriService: AssetUriService,
    public authService: AuthService,
    private router: Router,
  ) {
    this.authService.getAuthEmail().pipe(
      take(1),
      tap(email => this.emailAddress = email),
    ).subscribe();
  }

  goBack(): void {
    this.authService.getUser(true).pipe(
      take(1),
      switchMap(user => this.router.navigate(user ? [ROUTE_TOKEN_MAIN_BASE, 'accountSettings'] : [ROUTE_TOKEN_LOGIN])),
    ).subscribe();
  }
}
